<template>
  <div class="bind-body-page">
    <search-wrapper>
      <a-row :gutter="20">
        <a-col :span="6">
          <a-form-item label="第三方用户ID">
            <a-input
              @keyup.enter="handleSearch"
              placeholder="请输入第三方用户ID"
              v-model="outUserId"
              autocomplete="off"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="三维家账号">
            <a-input
              @keyup.enter="handleSearch"
              placeholder="请输入三维家账号"
              v-model="likeUserName"
              autocomplete="off"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="绑定时间">
            <a-range-picker v-model="dateRange" format="YYYY-MM-DD HH:mm:ss" style="width: 100%">
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item class="operation-group">
            <a-button icon="search" @click="handleSearch" >查询</a-button>
            <a-button class="reset-btn" icon="sync" @click="handleResetSearch">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </search-wrapper>
    <a-spin class="bind-body-page__spin" :spinning="isShowSpin">
        <div>
          <a-button :disabled="!hasSelected" @click="handleBindRelationBatchDelete">批量删除</a-button>
          <span style="margin-top:6px;font-size: 14px;font-weight: 400;color: rgba(0, 0, 0, 0.65);line-height: 20px;float: right">共 {{total}} 条</span>
        </div>
        <div class="bind-body-page__spin__table-body">
          <a-table
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            :columns="columns"
            :pagination="false"
            :data-source="localDataSource"
            :rowKey="handleRowKey"
            :scroll={y:200}
          >
            <template slot="operate" slot-scope="text, record">
              <a-popconfirm title="确认删除？" ok-text="确定" okType="danger" cancel-text="取消" @confirm="handleBindRelationDelete(record.relationId)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
    </a-spin>
    <div class="bind-body-page__footer">
      <a-pagination
        size="small"
        :current="index"
        :pageSize="size"
        :total="total"
        showSizeChanger
        showQuickJumper
        :showTotal="() => ``"
        @change="onChange"
        @showSizeChange="onChange"
        style="float: right"
      />
    </div>
  </div>
</template>

<script>
import {
  Table, Row, Col, Form,
} from 'ant-design-vue';
import moment from 'moment';
import SearchWrapper from '@/components/SearchWrapper';
import { listBindByPage, deleteRelation, deleteRelationBatch } from '@/services/modules/app-manage';

export default {
  name: 'BindRelationTable',
  components: {
    'a-table': Table,
    'a-row': Row,
    'a-col': Col,
    'a-form-item': Form.Item,
    SearchWrapper,
  },
  data() {
    return {
      outUserId: '',
      likeUserName: '',
      dateRange: [],
      isShowSpin: true,
      index: 1,
      size: 10,
      total: 0,
      localDataSource: [],
      selectedRowKeys: [],
    };
  },
  mounted() {
    this.getListData();
    this.dateRange = this.getInitDateRange();
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
    columns() {
      return [
        {
          title: '应用编号',
          dataIndex: 'appId',
        },
        {
          title: '第三方用户ID',
          dataIndex: 'outUserId',
        },
        {
          title: '三维家账号',
          dataIndex: 'userName',
        },
        {
          title: '三维家用户ID',
          dataIndex: 'userId',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' },
        },
      ];
    },
    defaultQueryParams() {
      let bTime;
      let eTime;
      if (this.dateRange && this.dateRange.length > 0) {
        bTime = this.dateRange[0].format('YYYY-MM-DD HH:mm:ss');
      } else {
        bTime = '';
      }
      if (this.dateRange && this.dateRange.length > 1) {
        eTime = this.dateRange[1].format('YYYY-MM-DD HH:mm:ss');
      } else {
        eTime = '';
      }
      return {
        appId: this.id,
        likeUserName: this.likeUserName,
        outUserId: this.outUserId,
        beginTime: bTime,
        endTime: eTime,
      };
    },
  },
  methods: {
    getInitDateRange() {
      const defaultSelectDate = {
        startDate: moment().startOf('day').subtract(7, 'days'),
        endDate: moment().startOf('day').add(1, 'days').subtract(1, 'seconds'),
      };
      return [defaultSelectDate.startDate, defaultSelectDate.endDate];
    },
    loadData(parameter) {
      return this.requestRecordListByPage({ ...parameter, ...this.defaultQueryParams });
    },
    requestRecordListByPage(param) {
      return listBindByPage(param);
    },
    handleSearch() {
      this.getListData();
    },
    handleResetSearch() {
      this.outUserId = '';
      this.likeUserName = '';
      this.selectedRowKeys = [];
      this.dateRange = this.getInitDateRange();
      this.handleSearch();
    },
    handleBindRelationBatchDelete() {
      const that = this;
      this.$confirm({
        title: '确认删除？',
        content: '删除后将移除绑定关系',
        centered: true,
        icon: (h) => h('a-icon', {
          attrs: {
            type: 'info-circle',
            theme: 'filled',
          },
        }),
        onOk() {
          const params = { relationIds: that.selectedRowKeys };
          deleteRelationBatch(params).then((res) => {
            if (res && res.success && res.result) {
              that.$message.success('删除成功');
              that.handleSearch();
              setTimeout(() => {
                that.selectedRowKeys = [];
              }, 1000);
            } else {
              that.$message.error((res && res.errorMessage) || '删除失败，请重试');
            }
          });
        },
        onCancel() {},
      });
    },
    handleBindRelationDelete(id) {
      const params = { relationId: id };
      deleteRelation(params).then((res) => {
        if (res && res.success && res.result) {
          this.$message.success('删除成功');
          this.handleSearch();
        } else {
          this.$message.error((res && res.errorMessage) || '删除失败，请重试');
        }
      });
    },
    getListData() {
      this.isShowSpin = true;
      this.loadData({
        pageIndex: this.index,
        pageSize: this.size,
      })
        .then((res) => {
          if (res.success) {
            const bizResult = res.result;
            this.index = bizResult.pageIndex || 1;
            this.total = bizResult.recordCount;
            this.localDataSource = bizResult.result;
          } else {
            this.index = 1;
            this.total = 0;
            this.localDataSource = [];
          }
          this.isShowSpin = false;
        })
        .catch(() => {
          this.index = 1;
          this.total = 0;
          this.localDataSource = [];
          this.isShowSpin = false;
        });
    },
    // 分页change事件
    onChange(page, pageSize) {
      this.index = page;
      this.size = pageSize;
      this.selectedRowKeys = [];
      this.getListData();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleCopy(value) {
      this.$copyText(value).then(this.$message.success('复制成功'));
    },
    handleRowKey(row) {
      return row.relationId;
    },
  },
};
</script>

<style lang="less" scoped>
  .bind-body-page {
    background: #F5F7FA;
    height: 100%;
    padding-bottom: 64px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    &__spin {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden!important;
      /deep/ .ant-spin-container{
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden!important;
      }
      &__table-body {
        margin-top: 18px;
        background: white;
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden!important;
        /deep/ .ant-table-wrapper {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden!important;
        }
        /deep/ .ant-spin-nested-loading {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden!important;
        }
        /deep/ .ant-table {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden!important;
        }
        /deep/ .ant-table-content {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden!important;
        }
        /deep/ .ant-table-scroll{
          flex: 1;
          height: 100%;
          flex-direction: column;
          overflow: hidden!important;
        }
        /deep/ .ant-table-thead {
          overflow: hidden!important;
        }
        /deep/ .ant-table-header {
          overflow: hidden!important;
          padding-bottom: 17px!important;
        }
        /deep/ .ant-table-body {
          overflow-y: auto !important;
          overflow-x: hidden !important;
          max-height: calc(100% - 60px)!important;
        }
        /deep/ .ant-table-placeholder{
          flex: 1;
          height: 100%;
          flex-direction: column;
          overflow: hidden!important;
        }
        /deep/ .ant-empty{
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden!important;
          align-items: center;
          justify-content: center;
        }
      }
    }
    &__footer {
      background: white;
      justify-content: space-between;
      height: 64px;
      padding: 20px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .reset-btn {
    margin-left:16px;
  }
</style>
